import {
  DEVICE_ACTION,
  SAVE_NOTIF,
  ADD_USER,
  SAVE_DEVICE,
  UPDATE_DEVICE,
  RESET_DEVICES_ACTION,
  SAVE_DEVICE_INFO_FONT_SIZE,
  RESET_DEVICES,
  UPDATED_DEVICE
} from '../actions/webView'
import { realtimeDB } from '@/firestoreDB'
import * as Sentry from '@sentry/vue'
import { apiCall } from '@/utils/api'
import {_} from 'vue-underscore'
import { RegisterEvent } from '../../analytics'

const getDefaultState = () => ({
  deviceData: [],
  pushNotif: '',
  fontSizeEm: 1
})

const state = getDefaultState()

const getters = {
  getDeviceInfo: state => () => state.deviceData,
  getPushPermission: state => () => state.pushNotif,
  getFontSizeDeviceInfo: state => state.fontSizeEm
}

const actions = {
  [ADD_USER]: ({ commit, getters, dispatch, state }, user) => {
    return new Promise((resolve, reject) => {
      const uniqueIdUser = state.deviceData.unique_id
      if (uniqueIdUser) {
        realtimeDB
          .ref(`/devices/${uniqueIdUser}`)
          .update({ user_id: getters.firebaseUUID() })
      }
      resolve(true)
    })
  },
  [DEVICE_ACTION]: ({ commit, getters, dispatch, state }, device) => {
    // browserLog(device)
    return new Promise((resolve, reject) => {
      try {
        let deviceInfo = device.params
        switch (device.category) {
          case 'info':
            const uniqueId = getters.getDeviceInfo().unique_id || deviceInfo.unique_id
            if (deviceInfo.pushNotifUpdate) {
              let today = new Date()
              deviceInfo.pushNotifUpdatedAt = today.toISOString()
            }
            if (uniqueId) {
              realtimeDB
                .ref(`/devices/${uniqueId}`)
                .update(deviceInfo)
                .then(() => {
                  apiCall({
                    url: '/api/v1.0/firebase/notify-device',
                    data: { device_id: uniqueId },
                    method: 'POST'
                  })
                })
            }
            commit(SAVE_DEVICE, deviceInfo)
            deviceInfo.fontSize && commit(SAVE_DEVICE_INFO_FONT_SIZE, deviceInfo.fontSize)
            break
          case 'event':
            RegisterEvent(device.action, device.params)
            break
        }
        resolve(deviceInfo)
      } catch (error) {
        Sentry.captureException(error)
        reject(error)
      }
    })
  },
  [RESET_DEVICES_ACTION]: ({ commit, getters }) => {
    commit(RESET_DEVICES)
  },
  [UPDATE_DEVICE]: ({ getters, commit }) => {
    return new Promise((resolve, reject) => {
      const uniqueId = getters.getDeviceInfo().unique_id
      if (uniqueId) {
        realtimeDB
          .ref(`/devices/${uniqueId}`)
          .child('user_id')
          .remove()
          .then(() => {
            apiCall({
              url: '/api/v1.0/firebase/notify-device',
              data: { device_id: uniqueId },
              method: 'POST'
            })
            commit(UPDATED_DEVICE, 'user_id')
            resolve(true)
          })
          .catch(error => {
            Sentry.captureException(error)
            reject(error)
          })
      }
    })
  }
}

const mutations = {
  [SAVE_DEVICE]: (state, deviceData) => {
    // browserLog({ SAVE_DEVICE_MUTATION: deviceData })
    state.deviceData = { ...state.deviceData, ...deviceData }
  },
  [SAVE_NOTIF]: (state, value) => {
    state.pushNotif = value
  },
  [SAVE_DEVICE_INFO_FONT_SIZE]: (state, value) => {
    state.fontSizeEm = value
  },
  [RESET_DEVICES]: state => {
    Object.assign(state, getDefaultState())
  },
  [UPDATED_DEVICE]: (state, value) => {
    state.deviceData = _.omit(state.deviceData, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/webView.js